$(function() {

  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 200) {
      // $('.header__heading-logo').addClass('noSeeMe');
      // $('#logo-swap').addClass('seeMe');
    } 
    
    if ($(window).scrollTop() < 25) {
      // $('.header__heading-logo').removeClass('noSeeMe');
      // $('#logo-swap').removeClass('seeMe');
    }
  });

  $('.home-module-inline-items').slick({
    slidesToShow: 5,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 1500,
    cssEase: "linear",
    infinite: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      }
    ]
  });
  
  
  if (window.location.href == 'https://theleecollective.com/') {
    $('body').addClass('home');

    $('.home-feature a').click(function(e) {
      if ($(this).hasClass('has-link')) {
        
      } else {
        e.preventDefault();
      }
    });

    $('.multicolumn-list__item.production .link').on('click', function(e) {
      // e.preventDefault();
      // $('.multicolumn-list__item.design video').prop('muted', false);
      // $('.multicolumn-list__item.production video').prop('muted', true);
      // $('.multicolumn-list__item.design').find('video')[0].play();
    });

    $('.multicolumn-list__item.design .link').on('click', function(e) {
      // e.preventDefault();
      // $('.multicolumn-list__item.production video').prop('muted', false);
      // $('.multicolumn-list__item.design video').prop('muted', true);
      // $('.multicolumn-list__item.production').find('video')[0].play();
    });

    $('.multicolumn-list__item.design').addClass('hovd');
    
    $('.multicolumn-list__item.design').hover(function() {
      $('.multicolumn-list__item.design').addClass('hovd');
      $('.multicolumn-list__item.production').addClass('shine');
    }, function () {
      $('.multicolumn-list__item.design').removeClass('hovd');
      $('.multicolumn-list__item.production').removeClass('shine');      
    });

    $('.multicolumn-list__item.production').hover(function() {
      $('.multicolumn-list__item.production').addClass('hovd');
      $('.multicolumn-list__item.design').addClass('shine');
    }, function () {
      $('.multicolumn-list__item.production').removeClass('hovd');
      $('.multicolumn-list__item.design').removeClass('shine');
    });
    
  }

  if (window.location.href.indexOf('https://theleecollective.com/blogs/lee-collective') > -1 || window.location.href.indexOf('https://theleecollective.com/blogs/annie-lee-carroll') > -1) {
    $('body').addClass('blog-page');
  }

  if (window.location.href.indexOf('https://theleecollective.com/blogs/lee-collective/') > -1 || window.location.href.indexOf('https://theleecollective.com/blogs/annie-lee-carroll/') > -1) {
    $('body').addClass('blog-article');
    $('.gal').slick({
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      cssEase: "linear",
      speed: 350,
      infinite: true,
      arrows: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    });
    
  }
});